var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgStatusGreenIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 14,
    viewBox: "0 0 16 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.2934 0.629761L5.08874 10.3418L1.70659 6.77323C1.54262 6.60021 1.27674 6.60021 1.11273 6.77323L0.122983 7.81752C-0.0409943 7.99053 -0.0409943 8.27107 0.122983 8.44412L4.79179 13.3702C4.95576 13.5433 5.22164 13.5433 5.38565 13.3702L15.877 2.30065C16.041 2.12764 16.041 1.8471 15.877 1.67405L14.8873 0.629761C14.7233 0.456746 14.4574 0.456746 14.2934 0.629761V0.629761Z",
    fill: "#23BD86"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStatusGreenIcon);
export default __webpack_public_path__ + "static/media/StatusGreenIcon.ce899bb0a5965749cbea40c936bfa876.svg";
export { ForwardRef as ReactComponent };